import React from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import { useParams, useRouteMatch } from 'react-router-dom'
import { CheckmarkIcon, DraftOutline12Icon } from 'assets/icons'
import contentTypeThemes from 'config/constants/contentTypeThemes'
import { arrayToSentenceFragment } from 'src/components/utils'
import { useOrganization } from 'src/graphql/hooks'
import CollectionListItemCard from '~/Profile/components/CollectionListItemCard'

const ProfileCollectionBlock = () => {
   const { userId } = useParams()
   const match = useRouteMatch()
   const { organization } = useOrganization()
   const enabledInitiativeTypes = organization.initiativeTypes.filter(t => t.enabled)

   // Initiative Types grouped by initiative class
   const groupedInitiativeTypes = enabledInitiativeTypes.reduce((result, initiativeType) => {
      if (!result[initiativeType.class]) {
         result[initiativeType.class] = []
      }

      result[initiativeType.class].push(initiativeType)
      return result
   }, {})

   const initiativeClasses = Object.keys(groupedInitiativeTypes)

   return (
      <View marginBottom="40px">
         <View paddingBottom="20px">
            <Text
               size="4"
               weight="medium"
               color="#111">
               Collection
            </Text>
         </View>
         <Grid columns="2[a] 3[b] 5[c] 4[d] 5[e] 6[f]" spacing="20px">
            {userId === 'me' && (
               <>
                  <GridCell>
                     <CollectionListItemCard
                        linkTo={`${match.url}/collection/following`}
                        icon={<CheckmarkIcon width="30px" height="30px" color="#fff" />}
                        name="Following"
                     />
                  </GridCell>
                  <GridCell>
                     <CollectionListItemCard
                        linkTo={`${match.url}/collection/drafts`}
                        icon={<DraftOutline12Icon width="30px" height="30px" color="#fff" />}
                        name="Drafts"
                     />
                  </GridCell>
               </>
            )}
            {initiativeClasses.map((initiativeClass) => {
               const initiativeGrouping = groupedInitiativeTypes[initiativeClass]
               const initiativeTypeNames = initiativeGrouping.map(t => t.namePlural)
               const Icon = contentTypeThemes[initiativeClass]?.icon

               return (
                  <GridCell key={initiativeClass}>
                     <CollectionListItemCard
                        linkTo={`${match.url}/collection/${initiativeClass}`}
                        icon={Icon && <Icon width="30px" height="30px" color="#fff" />}
                        name={arrayToSentenceFragment(initiativeTypeNames)}
                     />
                  </GridCell>
               )
            })}
         </Grid>
      </View>
   )
}

export default ProfileCollectionBlock
